var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmHome = function SvgBmHome(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BM_Home",
    transform: "translate(-670 -316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M-66.306,7.238-74.663,2.1a.645.645,0,0,0-.674,0l-8.357,5.143a.644.644,0,0,0-.211.885.643.643,0,0,0,.885.211l.949-.584V18.071a.642.642,0,0,0,.643.643h12.857a.642.642,0,0,0,.643-.643V7.749l.949.584a.643.643,0,0,0,.336.1.643.643,0,0,0,.548-.306A.644.644,0,0,0-66.306,7.238ZM-76.929,17.429V11.643h3.857v5.786Zm7.714-10.286V17.429h-2.571V11a.642.642,0,0,0-.643-.643h-5.143a.642.642,0,0,0-.643.643v6.429h-2.571V7.143a.614.614,0,0,0-.033-.165L-75,3.4l5.819,3.581A.614.614,0,0,0-69.214,7.143Z",
    transform: "translate(754 314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 18,
    height: 18,
    transform: "translate(670 316)",
    fill: "#fff",
    opacity: 0
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Home.4f27497a.svg";
export { ForwardRef as ReactComponent };